import { ChannelInfo } from 'interfaces/ChannelInfo';
import { Action } from 'redux';

import {
    ConnectionActionType,
    SetAuthedAction,
    SetChannelInfoAction,
    SetChannelInformBannerAction,
    SetConnectedAction,
    SetConnectionErrorAction,
    SetDisconnectedAction,
    SetManualReconnectAction,
    SetVoTokenToStoreAction,
} from './connection.actions';

const initialState = {
    connected: false,
    disconnected: false,
    authed: false,
    manualReconnect: false,
    channelInfo: null as ChannelInfo,
    error: null as { code: number; subCode?: number },
    token: null as string,
};

export const connectionReducer = (
    state = initialState,
    action: Action<ConnectionActionType>,
): typeof initialState => {
    switch (action.type) {
        case ConnectionActionType.SetConnected:
            const connected = (action as SetConnectedAction).payload;
            return { ...state, connected };

        case ConnectionActionType.SetDisconnected:
            const disconnected = (action as SetDisconnectedAction).payload;
            return { ...state, disconnected };

        case ConnectionActionType.SetAuthed:
            const authed = (action as SetAuthedAction).payload;
            return { ...state, authed };

        case ConnectionActionType.SetManualReconnect:
            const manualReconnect = (action as SetManualReconnectAction).payload;
            return { ...state, manualReconnect };

        case ConnectionActionType.SetChannelInfo:
            const channelInfo = (action as SetChannelInfoAction).payload;
            return { ...state, channelInfo };

        case ConnectionActionType.SetChannelInformBanner:
            const channelInformBanner = (action as SetChannelInformBannerAction).payload;
            return {
                ...state,
                channelInfo: { ...state.channelInfo, information_banner: channelInformBanner },
            };

        case ConnectionActionType.SetConnectionError:
            const error = (action as SetConnectionErrorAction).payload;
            return { ...state, error };

        case ConnectionActionType.SetVoTokenToStore:
            const token = (action as SetVoTokenToStoreAction).payload;
            return { ...state, token };

        default:
            return state;
    }
};
